
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { mask } from 'vue-the-mask';
    import { ControladorInterfaz } from '../../../controlador';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import moment from 'moment';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Pago } from '@/__env/lib/Ventas/Pagos';
    import * as Pagos from '@/__env/lib/Ventas/Pagos';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get SubModo() { return this.Controlador.Vista.BarraDerecha.SubModo; }
        public set SubModo( x: string ) { this.Controlador.Vista.BarraDerecha.SubModo = x; }
        public get Modo() { return this.Controlador.Vista.BarraDerecha.Modo; }
        public set Modo( x: string ) { this.Controlador.Vista.BarraDerecha.Modo = x; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.BarraDerecha.Anchura.Espacio; }

        public MascaraFecha = '##-##-####';
        public Pago: Pago = null;
        public Cajero: string = null;
        public Fecha: string = null;
        public Operacion: string = null;
        public Banco: string = '007 - BANCO PROVINCIA';
        public Importe: string = null;
        public Recibo: string = null;
        public Empresa: { Descripcion: string, Id: string; } | string = null;

        mounted()
        {
            this.Eventos.push( this.Controlador.Vista.BarraDerecha.onSubModo.subscribe( () =>
            {
                if ( this.SubModo == 'validar_pago' )
                {
                    this.Controlador.Vista.BarraDerecha.Anchura.Espacio = 400;
                }
            } ) );

            
            this.Pago = this.Controlador.Vista.BarraDerecha.Datos;

            this.Empresa = this.Pago.Cuenta;
            this.Cajero = this.Pago.Cajero;
            this.Fecha = this.Pago.Fechas.Creacion ? this.Pago.Fechas.Creacion.format( 'DD-MM-YYYY' ) : '';
            this.Operacion = this.Pago.Operacion;
            //this.Banco = this.Pago.Banco;
            this.Importe = this.Pago.Importes.Pagado.toString();
            this.SubModo = 'validar_pago';
            this.Iniciar();
        }



        public Cargando: boolean = false;
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }


        async Iniciar()
        {

        }

        public Validar()
        {
            let e: string[] = [];

            if ( !this.Empresa ) e.push( 'Ingrese empresa de destino' );
            if ( !this.Pago.Plataforma ) e.push( 'Ingrese tipo de operación' );
            if ( this.Pago.Plataforma && this.Pago.Plataforma.esTransferencia )
            {
                //   if ( !this.Cajero ) e.push( 'Ingrese cajero' );
                if ( !this.Operacion ) e.push( 'Ingrese nº operacion' );
                if ( !this.Importe || parseFloat( this.Importe ).isNan() || parseFloat( this.Importe ) <= 0 ) e.push( 'Ingrese importe' );
                if ( !this.Fecha ) e.push( 'Ingrese fecha' );
            }
            else if ( this.Pago.Plataforma && this.Pago.Plataforma.esDeposito )
            {
                if ( !this.Cajero ) e.push( 'Ingrese cajero' );
                if ( !this.Operacion ) e.push( 'Ingrese nº operacion' );
                if ( !this.Importe || parseFloat( this.Importe ).isNan() || parseFloat( this.Importe ) <= 0 ) e.push( 'Ingrese importe' );
                if ( !this.Fecha ) e.push( 'Ingrese fecha' );
            }

            else if ( this.Pago.Plataforma && this.Pago.Plataforma.esContado )
            {
                if ( !this.Importe || parseFloat( this.Importe ).isNan() || parseFloat( this.Importe ) <= 0 ) e.push( 'Ingrese importe' );
                if ( !this.Recibo ) e.push( 'Ingrese nº de recibo' );
            }


            return e;

        }
        public async Guardar()
        {
            let errores = this.Validar();
            if ( errores.hasRows() )
            {
                return await Utiles.Mensajes.Aceptar( 'Se encontraron errores', errores.map( x => `<li>${x}</li>` ).join( '' ) );
            }

            let opt: any = {};
            if ( this.Pago.Plataforma && this.Pago.Plataforma.esTransferencia )
            {
                opt = {
                    empresa: typeof this.Empresa === 'string' ? this.Empresa : this.Empresa.Id,
                    plataforma: this.Pago.Plataforma.Id,
                    importe: this.Importe,
                    banco: '007',//this.Banco,
                    cajero: this.Cajero,
                    operacion: this.Operacion,
                    fecha: moment( this.Fecha, 'DD-MM-YYYY' ).toSQL(),

                };
            }
            else if ( this.Pago.Plataforma && this.Pago.Plataforma.esDeposito )
            {
                opt = {
                    empresa: typeof this.Empresa === 'string' ? this.Empresa : this.Empresa.Id,
                    plataforma: this.Pago.Plataforma.Id,
                    importe: this.Importe,
                    banco: '007',// this.Banco,
                    cajero: this.Cajero,
                    operacion: this.Operacion,
                    fecha: moment( this.Fecha, 'DD-MM-YYYY' ).toSQL(),

                };
            }

            else if ( this.Pago.Plataforma && this.Pago.Plataforma.esContado )
            {
                opt = {

                    plataforma: this.Pago.Plataforma.Id,
                    importe: this.Importe,
                    recibo: this.Recibo,

                };
            }

             let crear = await this.Pago.Modificar( opt );
            if ( crear )
            {
                let rr = await this.Pedido.AgregarPagos( [crear] );
                if ( rr )
                {
                    window.location.reload();
                } else
                {
                    this.$EventBus.Notificaciones.Error( 'Error al adjuntar el pago' );
                }
            } else
            {
                this.$EventBus.Notificaciones.Error( 'Error al validar el pago' );
            }


        }


        public async AbrirComprobante( )
        {
            if ( this.Pago.Comprobante )
            {
                window.open( this.Pago.Comprobante );
            }
        }

        async Cerrar()
        {
            this.Modo = '';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
